import { Register } from './router'

const LoginModule = () => {
	const login = require(/* webpackChunkName: "login" */ '../modules/login')
	Register('login', login)
	return login
}

const RegisterModule = () => {
	const register = require(/* webpackChunkName: "register" */ '../modules/register')
	Register('register', register)
	return register
}

export { LoginModule, RegisterModule }
